/**
 * A quiet nod for anyone who opens the developer console.
 *
 * Prints a block in OpenPGP "ASCII armor" form (RFC 1991 / 4880): five-dash
 * header, `Key: value` headers, base64 body wrapped at 64 columns, a `=`-prefixed
 * CRC-24 checksum, and the matching trailer. The header says PUBLIC RECORD where
 * a real one would say PGP MESSAGE. The body is not encrypted, only encoded; the
 * checksum is the genuine CRC-24 so the block validates like the real thing.
 *
 * The payload is a line from Eric Hughes, "A Cypherpunk's Manifesto" (1993).
 */

const PAYLOAD =
  "We know that software can't be destroyed and that a widely dispersed system can't be shut down. -- Eric Hughes, 1993";

/** CRC-24 as specified for ASCII armor: init 0xB704CE, generator 0x864CFB. */
function crc24(bytes: Uint8Array): number {
  let crc = 0xb704ce;
  for (const b of bytes) {
    crc ^= b << 16;
    for (let i = 0; i < 8; i++) {
      crc <<= 1;
      if (crc & 0x1000000) crc ^= 0x1864cfb;
    }
  }
  return crc & 0xffffff;
}

export function printArmor(): void {
  try {
    const bytes = new TextEncoder().encode(PAYLOAD);
    const body = btoa(String.fromCharCode(...bytes)).match(/.{1,64}/g) ?? [];
    const sum = crc24(bytes);
    const checksum =
      '=' + btoa(String.fromCharCode((sum >> 16) & 0xff, (sum >> 8) & 0xff, sum & 0xff));

    console.info(
      [
        '-----BEGIN PUBLIC RECORD-----',
        'Version: 9/11receipts',
        '',
        ...body,
        checksum,
        '-----END PUBLIC RECORD-----',
      ].join('\n'),
    );
  } catch {
    /* purely decorative */
  }
}
